module.exports = __webpack_public_path__ + "static/media/heart-arrow_Diamonds.ad496c57.jpg";